import { useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedShowcase from './components/FeaturedShowcase';
import EducationalSection from './components/EducationalSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import ComparisonSection from './components/ComparisonSection';
import ConversionBanner from './components/ConversionBanner';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import { faqData } from '@/mocks/categories';

const SITE_URL = 'https://kakobuyfinds.monster';
const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Finds',
  url: SITE_URL,
  description: 'The Ultimate Kakobuy Spreadsheet Resource Hub — discover the best product finds, shopping guides, and spreadsheet comparisons.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  const categoryRef = useRef<HTMLDivElement>(null);

  const scrollToCategories = () => {
    categoryRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={[websiteSchema, faqPageSchema]} />

      <Navbar onCategoryClick={scrollToCategories} />

      <main>
        <HeroSection onExploreClick={scrollToCategories} />

        <div ref={categoryRef}>
          <CategoryGrid />
        </div>

        <FeaturedShowcase />

        <EducationalSection />

        <ComparisonSection />

        <ConversionBanner />

        <ArticleCardsSection />

        <TrustSection />

        <FAQSection />
      </main>

      <Footer />
    </div>
  );
}